
TS.ns('WL');

WL.leasingApplicationCreditDecisionModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;
          
        me.parent(config);

        me.watchProperty(me.Document.NoOverride, me.onNoOverrideChanged, me);
     
        var engineClassificationList = me.getDomainProperty('gcEngineScoringClassificationCollection_Property');
        if (engineClassificationList) {
            engineClassificationList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);

                        if (!dataItem.RowIsVisible) {
                            row.hide(); 
                            continue;
                        }
                    }
                } 
            }
        }
        
        var scoringDocumentDataList = me.getDomainProperty('gcScoringDocumentData_Property');
        if (scoringDocumentDataList) {
            scoringDocumentDataList.on('cellBeginEdit', me.onScoringDocumentDataBeginEdit);
        }
    },

    onNoOverrideChanged: function (newValue) {
        var me = this;

        if (newValue === true) {
                me.performServerCommand({
                    cmd: 'NoOverrideChanged',
                    submitModel: true,
                    extraData: { NewValue: true },
                    blockUI: true
                });
        }
    },

    onScoringDocumentDataBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        if (owner.Document.NoOverride())
            e.preventDefault();
    },
      
    _addApprovals: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddApprovals',
            submitModel: true,
            blockUI: false
        });
    },

    _editApprovals: function () {
        var me = this;

        var approvalsList = me.getDomainProperty('dgDocumentApproval_Property');
        if (approvalsList.SelectedItem() == null)
            me.performServerCommand({
                cmd: 'EditApprovals',
                submitModel: true,
                extraData: { UID: null },
                blockUI: false
            });
        else {
            me.performServerCommand({
                cmd: 'EditApprovals',
                submitModel: true,
                extraData: { UID: approvalsList.SelectedItem().UID() },
                blockUI: false
            });
        }
    },

    _delApprovals: function () {
        var me = this;

        var approvalsList = me.getDomainProperty('dgDocumentApproval_Property');
        if (approvalsList.SelectedItem() == null)
            me.performServerCommand({
                cmd: 'DeleteApprovals',
                submitModel: true,
                extraData: { UID: null },
                blockUI: false
            });
        else {
            me.performServerCommand({
                cmd: 'DeleteApprovals',
                submitModel: true,
                extraData: { UID: approvalsList.SelectedItem().UID() },
                blockUI: false
            });
        }
    },

    _viewApprovalHistory: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'ViewApprovalHistory',
            submitModel: true,
            blockUI: false
        });
    }

});

